import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Typography,
  Link as MUILink,
} from "@mui/material";
import LoginService from "../../services/loginService";
import DialogService from "../Dialog/dialogService";
import BackdropLoaderService from "../BackdropLoader/backdropLoaderService";

import PasswordRecoveryForm from "../PasswordRecoveryForm/PasswordRecoveryForm";
import GoogleSignIn from "../GoogleSignIn/GoogleSignIn";
import NotificationService from "../Notification/notificationService";
import { COLLECTION_TAB } from "../../pages/MyProfile/MyProfile";
import { COLLECTION_SECTION } from "../../pages/MyProfile/Collection/Collection";
import RedirectService from "../../services/redirectService";

import { LoginData } from "../../types/authTypes";

const LoginCard = () => {
  const navigate = useNavigate();

  const { error } = NotificationService();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { open: openBDL, close: closeBDL } = BackdropLoaderService();
  const { setLogin } = LoginService();
  const { openXS: openDialog } = DialogService();

  const forgot = async () => {
    openDialog("Password recovery", <PasswordRecoveryForm />, []);
  };

  const login = async () => {
    const { hasRedirectUrl } = RedirectService();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !password) {
      error("Email and password are required fields");
      return;
    }
    if (!emailRegex.test(email)) {
      error("Email must have a valid format");
      return;
    }
    openBDL();
    if (email && password) {
      let responseOk: undefined | LoginData = await setLogin(email, password);
      closeBDL();
      if (responseOk?.user) {
        closeBDL();
        // Only navigate to default profile if there's no redirect URL stored
        if (!hasRedirectUrl()) {
          navigate(
            "/my-profile/" +
              responseOk.user?.id +
              "/" +
              COLLECTION_TAB.COLLECTION +
              "/" +
              COLLECTION_SECTION.OVERVIEW
          );
        }
        // If there is a redirect URL, the storeLogin function will handle the navigation
      } else {
        error("Invalid email or password");
      }
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 450,
          paddingLeft: { xs: "0px", md: "50px" },
        }}
      >
        <Card
          sx={{
            padding: { xs: "1rem 0rem", sm: "1rem" },
            borderRadius: "10px",
          }}
          className="shadow-box"
        >
          <CardContent>
            <Box
              sx={{ display: "flex", flexDirection: "column", rowGap: 2 }}
              id="loginCardContainer"
            >
              <Box>
                <Typography
                  id="loginCardTitle"
                  variant="h4"
                  component="div"
                  textAlign="center"
                  sx={{ marginBottom: 2, fontWeight: "700 !important" }}
                >
                  Log In
                </Typography>
              </Box>

              <Box>
                <TextField
                  label="Email address"
                  id="filled-basic"
                  variant="filled"
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Box>
              <Box>
                <TextField
                  label="Password"
                  id="filled-basic"
                  variant="filled"
                  fullWidth
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      login();
                    }
                  }}
                />
              </Box>

              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box></Box>
                  <Box>
                    <MUILink
                      href="#"
                      variant="body2"
                      onClick={forgot}
                      sx={{ fontWeight: "500 !important" }}
                    >
                      Forgot password?
                    </MUILink>
                  </Box>
                </Box>
              </Box>

              <Box>
                <button
                  onClick={login}
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    textAlign: "center",
                    border: "none",
                    cursor: "pointer",
                  }}
                  className="default-btn move-right"
                >
                  <span>Log In</span>
                </button>
              </Box>

              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body2">
                    Don't have any account?
                  </Typography>
                  <Link to={"/sign-up"}>
                    <Typography variant="blueBoldText" sx={{ marginLeft: 1 }}>
                      Sign up
                    </Typography>
                  </Link>
                </Box>
              </Box>

              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: 35,
                      height: 35,
                      backgroundColor: "#4663ff",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                    }}
                  >
                    <Typography
                      variant="body1"
                      align="center"
                      sx={{ fontWeight: 700, fontSize: "1.15rem !important" }}
                    >
                      or
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box>
                <Typography
                  variant="body2"
                  align="center"
                  sx={{ fontWeight: "700 !important" }}
                >
                  Login with social media
                </Typography>
              </Box>

              <Box>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                  <GoogleSignIn />
                </Box>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default LoginCard;
